export type ScheduleFilter = 'late' | 'today' | 'week' | 'none';

export function matchesScheduleFilter(
    nextScheduledAt: string | null | undefined,
    filter: ScheduleFilter | null
): boolean {
    if (filter === null) return true;

    if (filter === 'none') return !nextScheduledAt;
    if (!nextScheduledAt) return false;

    const scheduled = new Date(nextScheduledAt);
    const now = new Date();

    if (filter === 'late') return scheduled < now;

    const endOfToday = new Date(now);
    endOfToday.setHours(23, 59, 59, 999);

    if (filter === 'today') return scheduled >= now && scheduled <= endOfToday;

    const endOfWeek = new Date(endOfToday);
    endOfWeek.setDate(endOfWeek.getDate() + 7);

    return scheduled >= now && scheduled <= endOfWeek;
}
